export type HourcodingIconProps = {
  icon?: IconHc;
} & React.SVGProps<SVGSVGElement>;

export enum IconHc {
  DAY = 'day',
  HOURCODING = 'hourcoding',
  NIGHT = 'night',
}
